import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBreakingNews = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_24900",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_24900)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.8335 14.0704C6.04294 14.0704 6.21815 13.9999 6.35912 13.859C6.50009 13.718 6.57058 13.5428 6.57058 13.3333C6.57058 13.1239 6.50009 12.9487 6.35912 12.8077C6.21815 12.6667 6.04294 12.5963 5.8335 12.5963C5.62405 12.5963 5.44884 12.6667 5.30787 12.8077C5.1669 12.9487 5.09641 13.1239 5.09641 13.3333C5.09641 13.5428 5.1669 13.718 5.30787 13.859C5.44884 13.9999 5.62405 14.0704 5.8335 14.0704ZM5.2085 11.154H6.4585V6.04167H5.2085V11.154ZM9.37516 13.9583H14.7918V12.7083H9.37516V13.9583ZM9.37516 10.625H14.7918V9.375H9.37516V10.625ZM9.37516 7.29167H14.7918V6.04167H9.37516V7.29167ZM3.58995 17.0833C3.16898 17.0833 2.81266 16.9375 2.521 16.6458C2.22933 16.3542 2.0835 15.9978 2.0835 15.5769V4.42313C2.0835 4.00215 2.22933 3.64583 2.521 3.35417C2.81266 3.0625 3.16898 2.91667 3.58995 2.91667H16.4104C16.8313 2.91667 17.1877 3.0625 17.4793 3.35417C17.771 3.64583 17.9168 4.00215 17.9168 4.42313V15.5769C17.9168 15.9978 17.771 16.3542 17.4793 16.6458C17.1877 16.9375 16.8313 17.0833 16.4104 17.0833H3.58995ZM3.58995 15.8333H16.4104C16.4745 15.8333 16.5333 15.8066 16.5866 15.7531C16.6401 15.6998 16.6668 15.641 16.6668 15.5769V4.42313C16.6668 4.35896 16.6401 4.30021 16.5866 4.24688C16.5333 4.1934 16.4745 4.16667 16.4104 4.16667H3.58995C3.52579 4.16667 3.46704 4.1934 3.4137 4.24688C3.36023 4.30021 3.3335 4.35896 3.3335 4.42313V15.5769C3.3335 15.641 3.36023 15.6998 3.4137 15.7531C3.46704 15.8066 3.52579 15.8333 3.58995 15.8333Z",
			fill: "#064C68"
		})
	})]
});
export default SvgBreakingNews;
